import * as React from 'react';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import {
    ISignInItem,
    ISignInLocalAccount,
    ISignInLoading,
    ISignInViewProps
} from '@msdyn365-commerce-modules/account-management/dist/types/modules/sign-in/sign-in';
import { ISignInConfig, ISignInProps, IGuestURLData } from '../definition-extensions/sign-in.ext.props.autogenerated';

const LocalAccount = (props: ISignInLocalAccount, guesturl: IGuestURLData | undefined): JSX.Element | null => {
    const { localAccount, items, forgetPassword, disclaimer, error, signInButton } = props;
    return (
        <Node {...localAccount}>
            {items &&
                items.map((item: ISignInItem) => {
                    return (
                        <Node key={item.key} {...item.wrapper}>
                            {item.label}
                            <span className={`icon-${item.key}`} />
                            {item.input}
                            {item.error}
                        </Node>
                    );
                })}
            <u>{forgetPassword}</u>
            {disclaimer}
            {error}
            {signInButton}
            <br />
            <br />
            {/* <button className='msc-sign-in continue-as-guest-btn'>
                {guesturl && guesturl.linkText && (
                    <a href={guesturl.linkUrl.destinationUrl}>{guesturl.linkText}</a>
                )}
            </button> */}
        </Node>
    );
};

const SignInLoading: React.FC<ISignInLoading> = ({ modal, modalBody, icon, message }) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const SignInView: React.FC<ISignInViewProps & ISignInProps<ISignInConfig>> = props => {
    const {
        signIn,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        signInSection,
        signUpSection,
        signInSectionHeading,
        signInLocalAccount,
        signUpSectionHeading,
        signUpLink,
        config
    } = props;
    const { guestURL } = config;
    return (
        <Module {...signIn}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <SignInLoading {...loading} />}
            <Node {...aadConainer}>
                <Node {...signInSection}>
                    {signInSectionHeading}
                    {LocalAccount(signInLocalAccount, guestURL)}
                    <Node {...signUpSection}>
                        {signUpSectionHeading}
                        {signUpLink}
                    </Node>
                </Node>
            </Node>
        </Module>
    );
};

export default SignInView;
